<template>
    <div class="card-poi">
        <div class="card-poi-panel">
            <div class="f6">
                {{data.name}}
            </div>
            <div class="card-poi-info f7">
                <p>{{data.address}}. {{data.city}}</p>
                <div><span v-if="data.distance">{{data.distance.toFixed(2)}} miles away</span></div>
            </div>
        </div>
        <div class="card-poi-footer" v-if="directionUrl">
          <a class="link" v-if="directionUrl" :href="directionUrl" target="_blank"><i class="icon-location-arrow"></i> Get Directions</a>
        </div>
    </div>
</template>

<script src="./mvt-cardpoi.js"></script>

<style lang="scss">
@use "./mvt-cardpoi.scss" as *;
</style>
